module.exports = __webpack_public_path__ + "img/2.d3df48a6.jpg";